module.exports = __webpack_public_path__ + "static/media/aw.9301ec6e.svg";